import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListTippableStaffOptions,
  ListTippableStaffResponse,
  listTippableStaff as universalListTippableStaff,
} from './tips-staff-v1-staff-tippable-staff.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function listTippableStaff(
  httpClient: HttpClient
): ListTippableStaffSignature {
  return (options?: ListTippableStaffOptions) =>
    universalListTippableStaff(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListTippableStaffSignature {
  /**
   * Retrieves a list of up to 100 staff who are eligible to receive tips, given
   * the provided filtering.
   * @param - Options to use when listing tippable staff.
   */
  (options?: ListTippableStaffOptions): Promise<
    NonNullablePaths<
      ListTippableStaffResponse,
      | `staff`
      | `staff.${number}.identificationData.anonymousVisitorId`
      | `staff.${number}.identificationData.memberId`
      | `staff.${number}.identificationData.wixUserId`
      | `staff.${number}.identificationData.appId`,
      5
    >
  >;
}

export {
  IdentificationData,
  IdentificationDataIdOneOf,
  IdentityType,
  ListTippableStaffOptions,
  ListTippableStaffRequest,
  ListTippableStaffResponse,
  Staff,
} from './tips-staff-v1-staff-tippable-staff.universal.js';
